import React from 'react';

import { CustomSVGProps } from '@cineamo/ui/src/icons/CustomSVGProps.types';

export function IconUp48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="up">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 12.5858L40.7071 29.2929L39.2929 30.7071L24 15.4142L8.70711 30.7071L7.2929 29.2929L24 12.5858Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconUp24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="up">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 5.58582L20.7071 14.2929L19.2929 15.7071L12 8.41424L4.70711 15.7071L3.29289 14.2929L12 5.58582Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconUp16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="up">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 3.58582L13.7071 9.29292L12.2929 10.7071L8 6.41424L3.70711 10.7071L2.29289 9.29292L8 3.58582Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
